import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/GlobalStore';

const defaultTimeoutMilliseconds = 5000;

const ScreenSaver = (props: { switchComponent: () => void; loop: boolean }) => {
  const veille = useSelector((state: RootState) => state.BotConfig.veille);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    if (!props.loop) {
      timer = setTimeout(
        props.switchComponent,
        veille?.screenSaver?.timeBeforeSwitch
          ? veille.screenSaver.timeBeforeSwitch * 1000
          : defaultTimeoutMilliseconds
      );
    }
    return () => { if (timer) clearTimeout(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        backgroundImage: `url(${veille?.screenSaver?.source})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    />
  );
};

export default ScreenSaver;
